/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiRequestOptions } from './ApiRequestOptions';

type Resolver<T> = (options: ApiRequestOptions) => Promise<T>;
type Headers = Record<string, string>;

export type OpenAPIConfig = {
	BASE: string;
	VERSION: string;
	WITH_CREDENTIALS: boolean;
	CREDENTIALS: 'include' | 'omit' | 'same-origin';
	TOKEN?: string | Resolver<string> | undefined;
	USERNAME?: string | Resolver<string> | undefined;
	PASSWORD?: string | Resolver<string> | undefined;
	HEADERS?: Headers | Resolver<Headers> | undefined;
	ENCODE_PATH?: ((path: string) => string) | undefined;
};
// 获取token的函数
const getToken = async (): Promise<string> => {
	// 从localStorage获取token
	const token = localStorage.getItem('token');
	return token || '';
};
// const getBaseUrl = () => {
// 	switch (process.env.NODE_ENV) {
// 		case 'development':
// 			return 'https://dev-lottery-member-api.seafintech.com';
// 		case 'production':
// 			return 'https://test-lottery-member-api.seafintech.com';
// 		case 'test':
// 			return 'https://test-lottery-member-api.seafintech.com';
// 		default:
// 			return 'https://test-lottery-member-api.seafintech.com';
// 	}
// };
export const API_BASE_URL =
	process.env.REACT_APP_API_BASE_URL || 'https://test-lottery-member-api.seafintech.com';
export const OpenAPI: OpenAPIConfig = {
	BASE: API_BASE_URL, // 改回原始地址
	VERSION: '1.0',
	WITH_CREDENTIALS: true, // 改为 true
	CREDENTIALS: 'include', // 改为 include
	TOKEN: getToken, // 使用函数来动态获取token
	USERNAME: undefined,
	PASSWORD: undefined,
	HEADERS: undefined,
	ENCODE_PATH: undefined,
};
